import axios from '@/libs/api.request'

/**
 * 获取列表
 * @returns {wx.RequestTask | never}
 */
export const getList = (params) => {
  return axios.request({
    url: 'payManage/rechargeConfig/index',
    method: 'get',
    params: params
  })
}

/**
 * 获取列表
 * @returns {wx.RequestTask | never}
 */
export const getWindowsParams = () => {
  return axios.request({
    url: 'payManage/rechargeConfig/getWindowsParams',
    method: 'get'
  })
}



/**
 * 锁定
 */
export const lock = (id) => {
  return axios.request({
    url: 'payManage/rechargeConfig/lock',
    method: 'get',
    params: {
      id: id
    }
  })
}

/**
 * 删除数据
 */
export const del = (id) => {
  return axios.request({
    url: 'payManage/rechargeConfig/del',
    method: 'get',
    params: {
      id: id
    }
  })
}

/**
 * 改变状态按钮
 * @param status
 * @param id
 * @returns {wx.RequestTask | never}
 */
export const changeStatus = (status, id) => {
  return axios.request({
    url: 'payManage/rechargeConfig/changeStatus',
    method: 'get',
    params: {
      status: status,
      id: id
    }
  })
}

/**
 * 新增
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const add = (data) => {
  return axios.request({
    url: 'payManage/rechargeConfig/add',
    method: 'post',
    data
  })
}

/**
 * 编辑
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const edit = (data) => {
  return axios.request({
    url: 'payManage/rechargeConfig/edit',
    method: 'post',
    data
  })
}
